<div class="app-role-container">
  <label>Filter by Role:</label>
  <mat-button-toggle-group [value]="value" (change)="onChange($event.value)">
    <mat-button-toggle *ngFor="let r of options" [value]="r.value">
      {{ r.label }}
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
